<template>
  <div
    class="m_pagedPublicationTemplate"
    :class="{ 'is--stacked': mode }"
    :style="setContainerContainer(publication)"
  >
    <div
      class="m_pageContainer"
      :style="setPageContainerProperties(publication)"
      v-for="page in all_pages"
      :key="page.id"
    >
      <div class="m_page" :style="setPageProperties(publication)">
        <div
          class="m_page--header"
          v-if="!!publication.header_left || !!publication.header_right"
        >
          <div>{{ publication.header_left }}</div>
          <div>{{ publication.header_right }}</div>
        </div>

        <MediaPublication
          v-for="media in getMediasOnPageID(page.id)"
          :key="media.metaFileName"
          :media="media"
          :page="page"
          :zoom="zoom"
        />
      </div>
    </div>
  </div>
</template>
<script>
import MediaPublication from "./subcomponents/MediaPublication.vue";

export default {
  props: {
    publication: Object,
    mode: String,
    zoom: {
      type: Number,
      default: 1,
    },
    show_page: Number,
  },
  components: {
    MediaPublication,
  },
  data() {
    return {};
  },

  created() {},
  mounted() {},
  beforeDestroy() {},

  watch: {},
  computed: {
    page_width() {
      return this.publication.hasOwnProperty("width")
        ? this.publication.width
        : 210;
    },
    page_height() {
      return this.publication.hasOwnProperty("height")
        ? this.publication.height
        : 297;
    },
    all_pages() {
      if (!!this.show_page)
        return this.publication.pages.slice(this.show_page - 1, this.show_page);
      else return this.publication.pages;
    },
  },
  methods: {
    getMediasOnPageID(id) {
      if (this.$root.state.dev_mode === "debug") {
        console.log(`METHODS • PagedPublicationTemplate: getMediasOnPageID`);
      }
      return Object.values(this.publication.medias).filter(
        (m) => m.page_id === id
      );
    },
    setContainerContainer() {
      if (this.$root.state.mode === "print_publication") return;

      if (this.mode === "stacked")
        return `
          width: ${this.page_width * this.zoom}mm;
          height: ${this.page_height * this.zoom}mm;
        `;
      return;
    },
    setPageContainerProperties() {
      if (this.$root.state.mode === "print_publication") return;

      return `
        width: ${this.page_width * this.zoom}mm;
        height: ${this.page_height * this.zoom}mm;
      `;
    },
    setPageProperties() {
      return `
        width: ${this.page_width}mm; 
        height: ${this.page_height}mm;
        transform: scale(${this.zoom});
      `;
    },
  },
};
</script>
<style lang="scss" scoped>
.m_pagedPublicationTemplate {
  position: relative;
  margin: 0 auto;
  overflow: visible;
  pointer-events: none;

  &.is--stacked .m_pageContainer {
    position: absolute;

    &:not(:first-child) {
      // z-index: -1;
    }
  }
}

.m_pageContainer {
  position: relative;
  pointer-events: auto;
  margin: 0 auto;
  transition: all 0.2s;
}

.m_page {
  position: relative;
  width: 300px;
  height: 300px;
  transform-origin: top left;

  // font-size: 90%;

  background-color: white;
  margin: 0;
  // box-shadow: 0px 4px 10px #999;
  box-shadow: 0px 0px 10px -5px var(--logo-blue);
}

.m_page--header {
  position: absolute;
  bottom: calc(100% - 1.4cm);
  padding: 0 1cm;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 10pt;
  font-weight: 500;
  text-transform: uppercase;

  &::after {
    content: "";
    position: absolute;
    border-bottom: 1px solid #000;
    left: 1cm;
    right: 1cm;
    bottom: 0;
  }
}
.m_page--media {
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // overflow: hidden;
  // font-weight: 400;

  // p,
  // h1,
  // h2,
  // h3,
  // h4 {
  //   margin: 0;
  // }

  // img,
  // video {
  //   position: relative;
  //   width: 100%;
  //   height: 100%;
  //   object-fit: cover;
  // }
}
</style>
